import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { DriverFormAtomProps } from "../DriverDetailsForm.types";

const NameFields = ({ control }: DriverFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Controller
        control={control}
        name={"firstname"}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("First Name")}
            errorMessage={error?.message}
            data-testid="driver--firstname"
            maxLength={25}
            preventConsecutiveSpaces={true}
          />
        )}
      />
      <Controller
        control={control}
        name={"lastname"}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("Last Name")}
            errorMessage={error?.message}
            data-testid="driver--lastname"
            maxLength={25}
            preventConsecutiveSpaces={true}
          />
        )}
      />
    </>
  );
};

export default NameFields;
